import { render, staticRenderFns } from "./DisplayText.vue?vue&type=template&id=8c790c4e&lang=pug&"
import script from "./DisplayText.vue?vue&type=script&lang=js&"
export * from "./DisplayText.vue?vue&type=script&lang=js&"
import style0 from "./DisplayText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports